module.exports = __webpack_public_path__ + "static/media/users.ebcd1ade.svg";